module.exports = __webpack_public_path__ + "img/dp-dy-df1.fb77979f.png";